<template>
    <v-row v-if="!$store.getters.progress" class="ma-0">
		<v-col class="pa-0">
            <show
                :id="id"
                :model-def="modelDef"
                :model-class="modelClass"
                :models="models"
                :infos="infos"
                :activities="true">
                <template slot="relations">
                    <v-col class="col-xs-12 pa-0 pb-4">
                        <v-card class="flex pa-0 background-2 round-card">
                            <v-card-title class="pa-3">
                                <p class="pl-2 pl-xl-3">Permessi</p>
                                <v-spacer></v-spacer>
                            </v-card-title>        
                            <v-divider></v-divider>
                            <v-container class="pa-0 px-2" fluid>
                                <v-row class="ma-0">
                                    <v-col class="pa-0" cols="12" sm="6" md="4" lg="3" xl="2" v-for="(module, module_name, m) in permissions" :key="m">
                                        <v-list dense two-line class="background-2">
                                            <v-subheader class="pl-4">{{ $trans(module_name) }}</v-subheader>
                                            <v-list-item v-for="(action, action_name, a) in module" :key="a">
                                                <v-list-item-action>
                                                    <v-checkbox color="primary" disabled v-model="permissions[module_name][action_name]"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ $trans(action_name) }}</v-list-item-title>
                                                    <v-list-item-subtitle :class="$eventBusUtility.colorOptionsRole(action)">{{ $eventBusUtility.transOptionsRole(action) }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item> 
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'role',
        props: {
            id: Number,
        },
        data() {
            return {
                modelDef: 'roles',
                modelClass: 'role',
                models: {},
                infos: {},
                permissions: {}
            }
        },

        created() {
            this.axios.get(this.modelDef + '/' + this.id).then(response => {
                this.models = response.data.models
                this.infos = response.data.infos
                this.permissions = response.data.models.role.permissions
                this.$store.commit('endProgress')

            }, response => {
                // error callback
            });
        },
    }
</script>
<style scoped>
    div >>> .v-list-item {
        min-height: 54px;
        min-height: 58px;
        -webkit-user-select: auto;
        user-select: auto;
    }
</style>